import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import AppShell from './AppShell';
import ReleaseForm from './components/ReleaseForm';
import BookingPage from './components/BookingPage';
import SettingsPage from './components/SettingsPage';
import PrepReader from './components/PrepReader';
import SupportPage from './components/SupportPage';
import SupportSuccess from './components/SupportSuccess';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <Routes>
            <Route path="/" element={<AppShell />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/release/:guestId" element={<ReleaseForm />} />
            <Route path="/prep/:guestId" element={<PrepReader />} />
            <Route path="/book/:showId" element={<BookingPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/support/listeners" element={<SupportPage audience="listeners" />} />
            <Route path="/support/guests" element={<SupportPage audience="guests" />} />
            <Route path="/support/success" element={<SupportSuccess />} />
          </Routes>
          <Toaster />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
